import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import UserRepository from '@/repositories/userRepository';
import { UserModel } from '@/models/user/userModel';
import { UserDetailModel } from '@/models/user/userDetailModel';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useUserStore = defineStore({
    id: 'user',
    state: () => ({
        userModel: new UserModel(),
        userDetail: new UserDetailModel(),
    }),
    getters: {},
    actions: {
        /**
         * ユーザー情報取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getUserAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const userRepository = new UserRepository();
            try {
                const response = await userRepository.getUserApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.userModel = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * ユーザー情報詳細取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getUserDetailAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const userRepository = new UserRepository();
            try {
                const response = await userRepository.getUserDetailApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: '', redirect: false, redirectUrl: '' };
                }
                this.userDetail = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        reset() {
            this.userModel = Object.assign({}, new UserModel());
            this.userDetail = Object.assign({}, new UserDetailModel());
        },
    },
    persist: {
        // セッションストレージに保存する。
        storage: sessionStorage,
    },
});
